import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="bg-white text-gray-800 px-6 md:px-16 lg:px-32 py-12">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-6">
        Terms & Conditions
      </h1>
      <p className="text-center text-sm text-gray-500 mb-12">
        Last Updated: July 1, 2025
      </p>

      <div className="space-y-8 leading-relaxed">
        {/* Introduction */}
        <section>
          <h2 className="text-xl font-semibold mb-2">Introduction</h2>
          <p>
            Welcome to VESHH-EON. By accessing our website or purchasing from us,
            you agree to the following Terms and Conditions. Please read them
            carefully.
          </p>
        </section>

        {/* General Use */}
        <section>
          <h2 className="text-xl font-semibold mb-2">General Use</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>The content on this website is subject to change without prior notice.</li>
            <li>
              We and any third parties do not provide warranties regarding the
              accuracy, completeness, timeliness, or suitability of the
              information provided. You acknowledge that such information may
              contain inaccuracies or errors, and we exclude liability for these
              to the fullest extent permitted by law.
            </li>
          </ul>
        </section>

        {/* User Responsibility */}
        <section>
          <h2 className="text-xl font-semibold mb-2">User Responsibility</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Your use of any information or materials on this site is entirely
              at your own risk.
            </li>
            <li>
              It is your responsibility to ensure that products, services, or
              information available through our website meet your requirements.
            </li>
          </ul>
        </section>

        {/* Intellectual Property */}
        <section>
          <h2 className="text-xl font-semibold mb-2">Intellectual Property</h2>
          <p>
            The website includes materials owned by or licensed to us, including
            design, layout, appearance, and graphics. Reproduction is prohibited
            unless otherwise permitted by the copyright notice. All trademarks
            not owned by us are acknowledged on the website.
          </p>
        </section>

        {/* Restrictions */}
        <section>
          <h2 className="text-xl font-semibold mb-2">Restrictions</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Unauthorized use of the information provided may give rise to
              claims for damages and/or constitute a criminal offense.
            </li>
            <li>
              You may not link to our website without prior written consent.
            </li>
          </ul>
        </section>

        {/* Third-Party Links */}
        <section>
          <h2 className="text-xl font-semibold mb-2">Third-Party Links</h2>
          <p>
            Our site may contain links to other websites for your convenience.
            We hold no responsibility for the content of linked sites.
          </p>
        </section>

        {/* Governing Law */}
        <section>
          <h2 className="text-xl font-semibold mb-2">Governing Law</h2>
          <p>
            Any disputes related to use of this site, purchases, or engagements
            with us shall be subject to the laws of India.
          </p>
        </section>

        {/* Limitation of Liability */}
        <section>
          <h2 className="text-xl font-semibold mb-2">Limitation of Liability</h2>
          <p>
            We hold no liability for any direct or indirect loss or damage
            arising out of the decline of authorization for any transaction,
            including instances where cardholders exceed preset limits agreed
            with our acquiring bank.
          </p>
        </section>
      </div>
    </div>
  );
}
